import Text from '../../../../components/Text'
import anayaImgUrls from '../../../../constants/anaya-constants'
import whiteCurveBg from '../../../../assets/images/programs/nivolumab/curve-white.svg'

const CoinDetails = () => {
  return (
    <section className="pb-[41px] callback-bg-anaya rounded-lg">
      <img
        src={whiteCurveBg}
        alt="nivolumab-hero"
        className="w-full object-cover mb-7"
      />
      <div className="px-5 pt-6">
        <div className="space-y-7">
          <Text tag="p" variant="headline" size="large" className="text-white">
            Get Care Coins in every cycle
          </Text>

          <Text tag="p" variant="body" size="large" className="text-cream">
            We're here to support and ease your financial burden for care. Each
            cycle of Anaya Care can help you get up to 250 care coins. These can
            be used to consult nutritionist, psycho/physio coach and book lab
            tests.
          </Text>
        </div>

        <div className="mb-5">
          <img
            src={anayaImgUrls.coinWallet}
            alt="care-specialist-banner"
            className="w-full h-auto max-h-[310px] object-scale-down"
          />
        </div>

        <div className="space-y-5 pt-5">
          <Text tag="p" variant="title" size="large">
            How can you use Care Coins?
          </Text>
          <Text tag="p" variant="body" size="large" className="text-cream">
            You can use your Care Coins to purchase any of the following
            services and products on the app
          </Text>
        </div>

        <div className="-mx-5 flex items-center overflow-x-auto gap-4 mt-6 pb-3">
          {anayaImgUrls.offers.map((offer) => (
            <div key={offer.title} className="w-[180px] first:ml-5 last:mr-5">
              <img
                src={offer.img}
                alt="offer"
                className="h-auto min-w-[180px] max-w-[180px]"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default CoinDetails
